import { classNames, Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

import { DocumentTheme, DocumentThemeDef } from "../models";

type Props = {
  name: string;
  link: string;
  imgSrc: string;
  theme: DocumentTheme;
};

@tag("nw-doc-user")
export class NWDocUser extends Component<Props> {
  static css = [tailwind];
  static propTypes = {
    name: String,
    link: String,
    imgSrc: String,
    theme: String,
  };

  render() {
    const themeDef = DocumentThemeDef[this.props.theme];

    return (
      <div class="flex items-center">
        <div class="rounded-full w-14 h-14">
          <img
            class="rounded-full w-full h-full object-cover"
            width={80}
            height={80}
            src={`${this.props.imgSrc}?size=sm`}
            alt="User avatar"
          />
        </div>
        <div class="ml-6">
          <p class={classNames("font-bold text-xl truncate max-w-[20ch]", themeDef.font)}>{this.props.name}</p>
          <p class={classNames("text-xl", themeDef.font)}>NextWork Student</p>
        </div>
      </div>
    );
  }
}
